import AbstractNode from './AbstractNode';
import {widthSizeText} from '../helper/grid';
import {parseJSON, stringifyJSON} from '../../Common/json';
import {decode, encode} from 'html-entities';

export default class GridColumn extends AbstractNode {
    get name() {
        return "grid_column";
    }

    get schema() {
        return {
            content: "block+",
            attrs: {
                width: {default: 16},
                color: {default: null},
                aligned: {default: 'left'},
                id: {default: null},
                version: {default: null},
                tasks: {default: null},
                filter: {default: null},
                inputParameters: {default: null},
                size: {default: 10},
            },
            parseDOM: [{
              tag: 'div.column', getAttrs: dom => ({
                width: dom.getAttribute("data-width"),
                color: dom.getAttribute("data-color"),
                aligned: dom.getAttribute("data-aligned"),
                id: dom.getAttribute("data-id"),
                version: dom.getAttribute("data-version"),
                tasks: parseJSON(decode(dom.getAttribute("data-tasks"))),
                filter: dom.getAttribute("data-filter"),
                inputParameters: parseJSON(decode(dom.getAttribute("data-input-parameters"))),
                size: Number(dom.getAttribute("data-size") || 10),
              })
            }],
            isolating: true,
            defining: true,
            toDOM: node => {
              return ["div", {
                'class': `${widthSizeText(node.attrs.width)} wide column${node.attrs.color ? ` ${node.attrs.color}` : ''}${node.attrs.aligned ? ` ${node.attrs.aligned} aligned` : ''}`.trim(),
                'data-width': node.attrs.width,
                'data-color': node.attrs.color,
                'data-aligned': node.attrs.aligned,
                'data-id': node.attrs.id,
                'data-version': node.attrs.version ? node.attrs.version : undefined,
                'data-tasks': node.attrs.tasks ? encode(stringifyJSON(node.attrs.tasks)) : undefined,
                'data-filter': node.attrs.filter,
                'data-input-parameters': node.attrs.inputParameters ? encode(stringifyJSON(node.attrs.inputParameters)) : undefined,
                'data-size': node.attrs.size,
              }, 0];
            }
        }
    }

    toMarkdown(state, node) {
        const isTaskColumn = node.attrs.id && node.attrs.tasks;
        state.ensureNewLine();
        state.write(`<div class="${widthSizeText(node.attrs.width)} wide column${node.attrs.color ? ` ${node.attrs.color}` : ''}${node.attrs.aligned ? ` ${node.attrs.aligned} aligned` : ''}" data-width="${node.attrs.width}"${node.attrs.color ? ` data-color="${node.attrs.color}"` : ''}${node.attrs.aligned ? ` data-aligned="${node.attrs.aligned}"` : ''}`);
        if (isTaskColumn) {
          state.write(` data-id="${node.attrs.id}" data-version="${node.attrs.version || ''}" data-tasks="${encode(stringifyJSON(node.attrs.tasks))}" data-filter="${encode(stringifyJSON(node.attrs.filter))}" data-input-parameters="${encode(stringifyJSON(node.attrs.inputParameters)) || ''}" data-size="${node.attrs.size}"`);
        }
        state.write('>\n\n');

        node.forEach((childNode, _, i) => {
          if (isTaskColumn) {
            childNode.taskListColumn = true;
          }
          state.render(childNode, node, i);
        });

        state.write('</div>');
        state.ensureNewLine();
    }

    get parseMarkdown() {
        return {
            block: "grid_column", getAttrs: token => ({
              width: token.attrGet("data-width"),
              color: token.attrGet("data-color"),
              aligned: token.attrGet("data-aligned"),
              id: token.attrGet("data-id"),
              version: token.attrGet("data-version"),
              tasks: parseJSON(decode(token.attrGet("data-tasks"))),
              filter: token.attrGet("data-filter"),
              inputParameters: parseJSON(decode(token.attrGet("data-input-parameters"))),
              size: token.attrGet("data-size"),
            })
        }
    }
}